


const base_url = "/api/contacts";

export const submitContact = (data) => {

    return fetch(`${base_url}/contact-us`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(data)
    }).then(results => {
        if(results.ok) {
            return results.json();
        }

        return Promise.reject(results.json())
    });
}
